
import AttendStampForm from './AttendStampForm';

export default AttendStampForm;
